// Copied from https://www.stitchfix.com/product/items/1179405
import { GetStitchFixClientQuery } from './getStitchFixClient';

type UseGetStitchFixClientQueryWrapper = {
  data: GetStitchFixClientQuery;
  extensions: {
    cost: {
      'graphql-api': {
        maxQueryCost: number;
        requestedQueryCost: number;
        actualQueryCost: number;
      };
    };
  };
};

export default {
  data: {
    visitor: {
      id: '47cfbabb-98a8-4544-b329-1d9aa46156d0',
    },
    client: {
      id: '19446542',
      businessLine: 'WOMENS',
      capabilities: {
        needsOnboarding: false,
        __typename: 'ClientCapabilities',
      },
      hasPurchases: true,
      __typename: 'Client',
    },
  },
  extensions: {
    cost: {
      'graphql-api': {
        maxQueryCost: 5000,
        requestedQueryCost: 38,
        actualQueryCost: 86,
      },
    },
  },
} as UseGetStitchFixClientQueryWrapper;
